export enum Accessor {
  Index = 'index',
  Data = 'data',
  Actions = 'actions',
}
